import type { SeverityBreakdown } from '@testflow/shared';
import { pickLang } from '../../lib/pick-lang.js';

// #90 Tint-Umbau: Balken tragen den SATTEN Ton (--sev-*-solid) — die hellen Badge-Tönungen
// wären auf dem Balken-Track nicht abgrenzbar.
const barTone = (token: string): string => {
  if (token === 'blocker') return 'bg-[var(--sev-blocker-solid)]';
  if (token === 'high') return 'bg-[var(--sev-high-solid)]';
  if (token === 'medium') return 'bg-[var(--sev-medium-solid)]';
  if (token === 'low') return 'bg-[var(--sev-low-solid)]';
  return 'bg-[var(--status-open)]'; // '__none__' / unbekannt
};

export function SeverityBars({ data, lang }: { data: SeverityBreakdown; lang: string }) {
  const max = Math.max(1, ...data.buckets.map((b) => b.openCount));
  return (
    <div className="space-y-2">
      {data.buckets
        .filter((b) => b.openCount > 0 || b.key !== '__none__')
        .map((b) => (
          <div key={b.key} className="flex items-center gap-3">
            <span className="w-24 shrink-0 text-xs text-text-body">
              {pickLang(lang, b.label_de, b.label_en)}
            </span>
            <div className="h-3 flex-1 overflow-hidden rounded-chip bg-bg-subtle">
              <div
                className={barTone(b.color_token)}
                style={{ width: `${Math.round((b.openCount / max) * 100)}%`, height: '100%' }}
              />
            </div>
            <span className="w-6 shrink-0 text-right text-xs font-bold text-text-primary">
              {b.openCount}
            </span>
          </div>
        ))}
    </div>
  );
}
